import React from "react"

/**
 * Mutes deeply all child components that consume this context.
 */
export const DeepMuteContext = React.createContext(false)

DeepMuteContext.displayName = "DeepMuteContext"
